export class Movement {
  id?: string;
  acm_id?: string;
  acm_name?: string;
  card_id?: string;
  customer_id?: any;
  customer_name?: string;
  reason_id?: string;
  reason_name?: string;
  division_id?: any;
  card_no?: string;
  store_id?: string;
  term_id?: any;
  xact_id?: any;
  sequence_id?: any;
  xact_date?: string;
  xact_time?: string;
  operator_id?: any;
  qty: number;
  value?: number;
  value2?: number;
  previous_balance?: number;
  previous_balance_2?: number;
  obj_code?: string;
  object_value?: number;
  ean?: string;
  discount?: number;
  action_type?: string;
  promo_code?: string;
  item_code?: string;
  flg_dsc_tot?: number;
  flg_dsc_item?: number;
  flg_manual?: number;
}

export class ManualMovementDto{
  id?: string;
  acm_id?: string;
  acm_name?: string;
  card_id?: string;
  customer_id?: any;
  customer_name?: string;
  reason_id?: string;
  reason_name?: string;
  division_id?: any;
  card_no?: string;
  store_id?: string;
  term_id?: any;
  xact_id?: any;
  sequence_id?: any;
  xact_date?: string;
  xact_time?: string;
  operator_id?: any;
  qty: number;
  value?: number;
  previous_balance?: number;
  previous_balance_2?: number;
  obj_code?: string;
  object_value?: number;
  ean?: string;
  discount?: number;
  action_type?: string;
  promo_code?: string;
  item_code?: string;
  flg_dsc_tot?: number;
  flg_dsc_item?: number;
  flg_manual?: number;
  channel_code?: string;
  store_code?: string;
  reason_code?: string;
  acm_code?: string;
}

export class ExternalMovements {
  id?: number;
  acm_code: string;
  card_id: number;
  customer_id: number;
  reason_code: string;
  division_id: number;
  card_no: string;
  store_code: string;
  store_id: number;
  term_id: number;
  flg_manual: string;
  sequence_id: number;
  xact_id: number;
  xact_date: string;
  xact_time: string;
  operator_id: number;
  item_code: string;
  ean: string;
  discount: number;
  action_type: string;
  promo_code: string;
  qty: number;
  flg_dsc_tot: string;
  flg_dsc_item: string;
  value: number;
  value_2: number;
  previous_balance: number;
  previous_balance_2: number;
  obj_code: string;
  object_value: number;
}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-movement.model.ts